import {IApiRouteService} from '../../models/route';

export abstract class IApiBackendRouteService extends IApiRouteService {
}
